import React from 'react';
import clsx from 'clsx';
import { ProductType, RegisterMode } from 'cart-model';
import { useTranslation } from 'react-i18next';
import { Typography, Link } from 'ui-components';
import { logSelectRetirementType } from '../../model/events';
import { RetirementProductConfig } from './RetirementProductCard.types';

import useStyles from './IkeOrIkzeMobile.style';

interface MobileAdditionalActionsRowProps {
  ikeConfig: RetirementProductConfig;
  ikzeConfig: RetirementProductConfig;
  onProductTypeChange: (productType: ProductType, registerMode: RegisterMode) => void;
}

const MobileAdditionalActionsRow: React.FC<MobileAdditionalActionsRowProps> = ({
  ikeConfig,
  ikzeConfig,
  onProductTypeChange
}) => {
  const { t } = useTranslation('ike-or-ikze');
  const c = useStyles({});

  const handleActionClick = (productType: ProductType, registerMode: RegisterMode): void => {
    onProductTypeChange(productType, registerMode);
    logSelectRetirementType();
  };

  return (
    <div className={c.additionalActionRow}>
      <div className={c.additionalActionCell}>
        <div className={c.additionalActionBox}>
          <div>
            <Typography className={c.productItemLabel}>
              {t(ikeConfig.transferLabelKey)}
            </Typography>
            <Link variant="underline"
            as="navlink" to={ikeConfig.transferRoute}
            className={c.link}
            onClick={() => handleActionClick(ikeConfig.productType, ikeConfig.transferRegisterMode)}>
              {t(ikeConfig.transferButtonLabelKey)}
            </Link>
          </div>
          <div>
            <Typography className={c.productItemLabel}>
              {t(ikeConfig.korpoLabelKey)}
            </Typography>
            <Link variant="underline"
            as="navlink" to={ikeConfig.korpoRoute}
            className={c.link}
            onClick={() => handleActionClick(ikeConfig.productType, ikeConfig.korpoRegisterMode)}>
              {t(ikeConfig.korpoButtonLabelKey)}
            </Link>
          </div>
        </div>
      </div>

      <div className={c.additionalActionCell}>
        <div className={clsx(c.additionalActionBox, c.additionalActionBoxWithBorder)}>
          <div>
            <Typography className={c.productItemLabel}>
              {t(ikzeConfig.transferLabelKey)}
            </Typography>
            <Link variant="underline"
            as="navlink" to={ikzeConfig.transferRoute}
            className={c.link}
            onClick={() => handleActionClick(ikzeConfig.productType, ikzeConfig.transferRegisterMode)}>
              {t(ikzeConfig.transferButtonLabelKey)}
            </Link>
          </div>

          <div>
            <Typography className={c.productItemLabel}>
              {t(ikzeConfig.korpoLabelKey)}
            </Typography>
            <Link variant="underline"
            as="navlink" to={ikzeConfig.korpoRoute}
            className={c.link}
            onClick={() => handleActionClick(ikzeConfig.productType, ikzeConfig.korpoRegisterMode)}>
              {t(ikzeConfig.korpoButtonLabelKey)}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAdditionalActionsRow;
